var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 900,
    viewBox: "0 0 300 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        fill: #de1927;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 190.58,
    y: 55.12,
    width: 95.78,
    height: 43.87
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 190.58,
    y: 55.12,
    width: 95.78,
    height: 43.87
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "210.75 64.84 214.81 73.79 220.22 62.23 226.42 62.23 230.5 91.96 222.57 91.96 220.84 79.73 220.76 79.73 214.81 91.96 209.2 79.83 210.75 64.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "201.39 62.23 198.15 91.96 205.68 91.96 208.92 62.23 201.39 62.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "232.35 62.27 240.42 62.27 240.44 66.24 236.28 66.24 236.28 67.81 239.38 67.81 239.38 71.79 236.28 71.79 236.28 73.36 240.43 73.36 240.44 77.34 232.35 77.34 232.35 62.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "242.03 62.27 251.33 62.27 251.3 66.08 248.65 66.08 248.65 77.34 244.72 77.34 244.72 66.08 242.04 66.08 242.03 62.27"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m256.79,69.34c1.47,0,2.36-.5,2.36-1.86s-.9-1.86-2.36-1.86v3.72Zm-3.93-7.07h5.17c2.99,0,5.06,1.63,5.06,4.84,0,1.61-.73,2.83-2.05,3.71l2.89,6.53h-4.44l-2.66-6.22h-.04v6.22h-3.93v-15.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m271.71,66.08c-1.96,0-3.6,1.66-3.6,3.73s1.64,3.73,3.6,3.73,3.6-1.74,3.6-3.73-1.62-3.73-3.6-3.73m0,11.37c-4.07,0-7.49-3.42-7.49-7.65s3.42-7.65,7.49-7.65,7.49,3.42,7.49,7.65-3.42,7.65-7.49,7.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m241.5,90.26h-5.31v-2.77h5.54c1.02,0,1.49.46,1.5,1.44,0,.9-.54,1.33-1.73,1.34m-5.31-7.08h5.48c.4,0,.71.12.93.35.23.23.34.55.34.95,0,.37-.12.68-.38.94-.26.26-.57.39-.95.39h-5.42v-2.63Zm7.24,3.37c.7-.52,1.05-1.25,1.05-2.16,0-.86-.26-1.57-.77-2.1-.52-.53-1.23-.79-2.12-.79h-6.97v10.43h6.87c1.1,0,1.94-.23,2.51-.69.57-.46.85-1.17.85-2.08,0-1.3-.47-2.19-1.41-2.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m248.96,87.99l2.16-4.81,2.13,4.81h-4.29Zm3.06-6.47h-1.83l-4.65,10.44h1.59l1.01-2.33h5.93l1.01,2.33h1.6l-4.65-10.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m267,91.89v-.07.07Zm-1.82.07l-5.55-8.27v8.27h-1.58v-10.43h1.89l5.55,8.28v-8.28h1.58v10.43h-1.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "279.21 91.84 279.3 91.96 277.28 91.96 273.16 86.59 271.18 88.79 271.18 91.96 269.61 91.96 269.61 81.53 271.18 81.53 271.18 86.76 276.58 81.53 278.87 81.53 274.35 85.5 279.21 91.84"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m5.89,47.69V2.93h9.85v44.76H5.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m46.29,47.69v-19.12c0-4.6-2.17-6.97-5.88-6.97s-6.07,2.37-6.07,6.97v19.12h-9.72V13.42h9.72v4.86c2.24-2.88,5.12-5.5,10.04-5.5,7.35,0,11.64,4.86,11.64,12.72v22.19h-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m81.14,47.95h-8.82l-13.49-34.53h10.29l7.67,22.95,7.74-22.95h10.1l-13.49,34.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m113.87,48.46c-10.61,0-18.48-7.86-18.48-17.71v-.13c0-9.85,7.93-17.84,18.61-17.84s18.48,7.86,18.48,17.71v.13c0,9.85-7.93,17.84-18.61,17.84Zm9.01-17.84c0-5.05-3.64-9.46-9.01-9.46s-8.89,4.28-8.89,9.34v.13c0,5.05,3.64,9.46,9.02,9.46s8.89-4.28,8.89-9.34v-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m138.42,9.65V1.02h10.23v8.63h-10.23Zm.26,38.04V13.42h9.72v34.27h-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m172.44,48.46c-10.29,0-17.84-7.93-17.84-17.71v-.13c0-9.78,7.48-17.84,17.97-17.84,6.46,0,10.49,2.17,13.68,5.75l-5.95,6.39c-2.17-2.3-4.35-3.77-7.8-3.77-4.86,0-8.31,4.28-8.31,9.34v.13c0,5.24,3.39,9.46,8.7,9.46,3.26,0,5.5-1.41,7.86-3.64l5.69,5.75c-3.32,3.64-7.16,6.27-14,6.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m222.37,33.94h-23.85c.96,4.41,4.03,6.71,8.38,6.71,3.26,0,5.63-1.02,8.31-3.52l5.56,4.92c-3.2,3.96-7.8,6.39-14,6.39-10.29,0-17.9-7.22-17.9-17.71v-.13c0-9.78,6.97-17.84,16.94-17.84,11.45,0,16.69,8.89,16.69,18.6v.13c0,.96-.06,1.54-.13,2.43Zm-16.56-13.36c-4.03,0-6.65,2.88-7.42,7.29h14.64c-.58-4.35-3.13-7.29-7.23-7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m241.45,47.69V2.93h9.85v44.76h-9.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m271.76,48.27c-5.95,0-9.97-2.37-9.97-10.29v-16.24h-4.09v-8.31h4.09V4.66h9.72v8.76h8.06v8.31h-8.06v14.64c0,2.24.96,3.32,3.13,3.32,1.79,0,3.39-.45,4.79-1.22v7.8c-2.05,1.22-4.41,1.98-7.67,1.98Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m159.15,92.02h-2.93l-2.2-7.02-2.24,7.02h-2.9l-3.52-11.53h3.29l1.84,6.94,2.16-6.98h2.8l2.18,7,1.88-6.96h3.22l-3.56,11.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m164.74,79.23v-2.88h3.42v2.88h-3.42Zm.09,12.7v-11.45h3.25v11.45h-3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m174.99,92.12c-1.99,0-3.33-.79-3.33-3.44v-5.42h-1.37v-2.78h1.37v-2.92h3.25v2.92h2.69v2.78h-2.69v4.89c0,.75.32,1.11,1.05,1.11.6,0,1.13-.15,1.6-.41v2.6c-.68.41-1.47.66-2.56.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m187.22,91.93v-6.38c0-1.54-.73-2.33-1.96-2.33s-2.03.79-2.03,2.33v6.38h-3.25v-15.59h3.25v5.77c.75-.96,1.71-1.84,3.35-1.84,2.45,0,3.89,1.62,3.89,4.25v7.41h-3.25Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.69a368ced4e3c5dc2cc1606239eece98.svg";
export { ForwardRef as ReactComponent };